var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTellMeMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_1002_1718)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2568 17.9976H113.917C115.091 18.0163 116.243 18.2805 117.307 18.7675C118.37 19.2543 119.316 19.9514 120.098 20.8072C120.88 21.6628 121.483 22.6613 121.883 23.7406C122.278 24.8052 122.47 25.9343 122.452 27.0668V86.7212L122.422 86.9648C122.151 89.168 121.159 91.241 119.569 92.8145C117.974 94.3923 115.873 95.3686 113.614 95.5229L113.478 95.5322H15.1931C14.0191 95.5135 12.8663 95.2493 11.8028 94.7623C10.7398 94.2755 9.79351 93.5784 9.01165 92.7225C8.23022 91.8671 7.62696 90.8687 7.2268 89.7893C6.83214 88.7246 6.64015 87.5953 6.65731 86.4628V27.067C6.64015 25.9344 6.83217 24.8052 7.2268 23.7406C7.62687 22.6614 8.23005 21.6628 9.01165 20.8072C9.79351 19.9514 10.7398 19.2543 11.8028 18.7675C12.8663 18.2805 14.0191 18.0168 15.1931 17.9981L15.2568 17.9976ZM15.3054 25.9976C15.252 26.0003 15.1943 26.0133 15.1337 26.0411C15.0667 26.0718 14.9912 26.123 14.9181 26.203C14.8447 26.2833 14.7767 26.3898 14.728 26.5213C14.6792 26.653 14.6534 26.8 14.6565 26.9518L14.6573 26.9921V86.5377L14.6565 86.578C14.6534 86.7299 14.6792 86.877 14.728 87.0086C14.7766 87.1398 14.8446 87.2463 14.9181 87.3268C14.9912 87.4068 15.0667 87.458 15.1337 87.4887C15.1943 87.5164 15.252 87.5295 15.3054 87.5322H113.158C113.423 87.4946 113.7 87.3675 113.942 87.1276C114.181 86.8916 114.369 86.5595 114.452 86.1666V26.9921L114.453 26.9518C114.456 26.7999 114.431 26.653 114.382 26.5213C114.333 26.3898 114.265 26.2833 114.192 26.203C114.118 26.1229 114.043 26.0718 113.976 26.0411C113.915 26.0133 113.858 26.0003 113.804 25.9976H15.3054Z",
    fill: "url(#paint0_linear_1002_1718)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5924 107.331C39.5924 105.122 41.3833 103.331 43.5924 103.331H85.4989C87.7081 103.331 89.4989 105.122 89.4989 107.331C89.4989 109.54 87.7081 111.331 85.4989 111.331H43.5924C41.3833 111.331 39.5924 109.54 39.5924 107.331Z",
    fill: "url(#paint1_linear_1002_1718)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1002_1718)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5183 63.0705C54.4609 62.8914 54.2441 62.8914 54.1867 63.0705L53.6904 64.6171C53.2925 65.8572 52.3567 66.8519 51.1431 67.3246C50.9817 67.3875 50.9817 67.6544 51.1431 67.7173C52.3567 68.19 53.2925 69.1847 53.6904 70.4248L54.1867 71.9714C54.2441 72.1505 54.4609 72.1505 54.5183 71.9714L55.0105 70.4374C55.4103 69.1915 56.3505 68.1922 57.5697 67.7173C57.7312 67.6544 57.7312 67.3875 57.5697 67.3246C56.3505 66.8496 55.4103 65.8504 55.0106 64.6045L54.5183 63.0705Z",
    fill: "url(#paint2_linear_1002_1718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3731 41.5834C49.2965 41.3447 49.0075 41.3447 48.9309 41.5834L48.2692 43.6457C47.7386 45.2991 46.4909 46.6253 44.8729 47.2556C44.6576 47.3395 44.6576 47.6954 44.8729 47.7792C46.491 48.4095 47.7386 49.7357 48.2692 51.3892L48.9309 53.4514C49.0075 53.6901 49.2965 53.6901 49.3731 53.4514L50.0294 51.4061C50.5625 49.7449 51.816 48.4125 53.4416 47.7792C53.6569 47.6954 53.6569 47.3395 53.4416 47.2556C51.816 46.6224 50.5625 45.29 50.0294 43.6288L49.3731 41.5834Z",
    fill: "url(#paint3_linear_1002_1718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7135 41.0194C72.522 40.4226 71.7996 40.4226 71.608 41.0194L68.8027 49.7619C68.2045 51.6264 66.7975 53.1218 64.973 53.8326L61.4629 55.1999C60.9247 55.4096 60.9247 56.2992 61.4629 56.5089L64.973 57.8762C66.7976 58.587 68.2045 60.0824 68.8028 61.9469L71.608 70.6892C71.7996 71.2861 72.522 71.2861 72.7135 70.6892L75.515 61.9586C76.1133 60.0941 77.5202 58.5987 79.3448 57.8879L82.8848 56.5089C83.423 56.2992 83.423 55.4096 82.8848 55.1999L79.3449 53.8209C77.5203 53.1101 76.1133 51.6147 75.5151 49.7502L72.7135 41.0194Z",
    fill: "url(#paint4_linear_1002_1718)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1002_1718",
    x1: 6.65623,
    y1: 111.331,
    x2: 130.317,
    y2: 99.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1002_1718",
    x1: 6.65623,
    y1: 111.331,
    x2: 130.317,
    y2: 99.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1002_1718",
    x1: 44.7114,
    y1: 72.1056,
    x2: 85.9188,
    y2: 68.1796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1002_1718",
    x1: 44.7114,
    y1: 72.1056,
    x2: 85.9188,
    y2: 68.1796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1002_1718",
    x1: 44.7114,
    y1: 72.1056,
    x2: 85.9188,
    y2: 68.1796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_1718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.664062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1002_1718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(38 31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTellMeMore);
export default __webpack_public_path__ + "static/media/TellMeMore.6a8dad84efe7c5361d933a225ab84b4c.svg";
export { ForwardRef as ReactComponent };